import React from "react";
import { NavLink } from "react-router-dom";

/**
 * @typedef {{ id: string, label: string, path: string, icon?: React.ComponentType<any> }} TabItem
 */

/**
 * @param {{ tabs: TabItem[] }} props
 */
const TabNavigation = ({ tabs }) => {
  return (
    <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <nav className="flex gap-2 overflow-x-auto py-3" aria-label="Tabs">
          {tabs.map((tab) => (
            <NavLink
              key={tab.id}
              to={tab.path}
              end
              className={({ isActive }) =>
                [
                  "relative inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm whitespace-nowrap group",
                  isActive
                    ? "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white"
                    : "text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800/60 hover:text-gray-900 dark:hover:text-white",
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  {tab.icon && (
                    <tab.icon
                      className={[
                        "h-5 w-5",
                        isActive
                          ? "text-secondary dark:text-secondary"
                          : "text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300",
                      ].join(" ")}
                    />
                  )}
                  <span>{tab.label}</span>
                  {isActive && (
                    <span className="absolute -bottom-2 left-0 right-0 mx-auto h-0.5 w-8 rounded bg-secondary dark:bg-secondary" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;
